module.exports = __webpack_public_path__ + "static/media/marketing-changyan.83f06860.png";